import styled from "@emotion/styled";
import { pascalCase } from "change-case";
import type { ReactNode } from "react";

import { useFormatMessage } from "@skilitics/localization";

interface Props {
  singularName: ReactNode;
  arrayOperator: ReactNode;
  objectOperator: ReactNode;
  objectPropertyName: ReactNode;
  resultPropertyName: ReactNode;
  value: ReactNode;
}

export const Container = styled.div``;

export const Word = styled.span`
  &::before {
    content: " ";
  }

  &::after {
    content: " ";
  }
`;

const BoldWord = styled(Word)`
  color: ${({ theme }) => theme.secondary};
  font-weight: bold;
`;

const Configure = styled.span`
  font-style: italic;
  opacity: 0.5;
`;

export const ObjectArrayConditionBuilderSummary = ({
  singularName,
  arrayOperator,
  objectOperator,
  objectPropertyName,
  resultPropertyName,
  value,
}: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const arrayName = typeof resultPropertyName === "string" ? pascalCase(resultPropertyName) : resultPropertyName;

  return (
    <Container>
      {arrayOperator && objectOperator && value !== undefined ? (
        <>
          <Word>{arrayName}</Word>
          <BoldWord>{arrayOperator}</BoldWord>
          <Word>{singularName}</Word>
          <Word>{formatMessage("with")}</Word>
          <BoldWord>{objectPropertyName}</BoldWord>
          <Word>{formatMessage("which")}</Word>
          <BoldWord>{objectOperator}</BoldWord>
          <BoldWord>{value}</BoldWord>
        </>
      ) : (
        <Configure>{formatMessage("configure")}</Configure>
      )}
    </Container>
  );
};

const formatStrings = {
  configure: {
    en: "Click to configure",
  },
  which: {
    en: "which",
  },
  with: {
    en: "with",
  },
};
